import React, {useState} from "react";
import {Collector} from "../../Types/CollectorTypes";
import {Col, Row} from "reactstrap";
import WidgetInformationWithIcon from "../../../../CommonComponents/Dashboard/DashboardWidget";
import {Trello, Users, TrendingUp, DollarSign} from "react-feather";

interface collectorDashboardProps {
    collector: Collector
}

const CollectorDashboard = ({collector}: collectorDashboardProps) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);


    return (
        <div>
            <Row>
                <Col xxl='auto' xl='3' sm='6' className='box-col-6'>
                    <Row>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Participants',
                                gros: 5,
                                total: collector.statistics?.participants,
                                color: 'secondary',
                                icon: <Users size={16} color={'purple'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Boards',
                                gros: 50,
                                total: collector.statistics?.boards,
                                color: 'primary',
                                icon: <Trello size={16} color={'orange'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Sales',
                                gros: 20,
                                total: collector.statistics?.cash,
                                color: 'success',
                                icon: <TrendingUp size={16} color={'green'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Earnings',
                                gros: 10,
                                total: collector.statistics?.points,
                                color: 'default',
                                icon: <DollarSign size={16} color={'blue'}/>,
                            }}/>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

export default CollectorDashboard;
